import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, Spinner } from 'react-bootstrap'

const UpdateRuleModal = ({ show, onClose, rule, onSubmit, updateRuleState }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <h4>{rule.active ? 'Inactivate' : 'Activate'} Rule</h4>
      </Modal.Header>
      <Modal.Body className='font-85'>
        <p>
          Are you sure you want to make this rule {rule.active ? 'inactive' : 'active'}? 
        </p>
        <p>
          {rule.active ? 'This action will also clear any associated Orders, Clinical Ed or Patient Ed.' : null}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose} className='font-85'>
          Cancel
        </Button>
        <Button variant='primary' onClick={onSubmit} className='font-85' disabled={updateRuleState.loading}>
          {updateRuleState.loading ? <Spinner animation='border' role='status' size='sm' />  : 'Save Changes'}
        </Button> 
      </Modal.Footer>
    </Modal>
  )
}

export default UpdateRuleModal

UpdateRuleModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  rule: PropTypes.shape({
    description: PropTypes.string,
    active: PropTypes.number
  }),
  onSubmit: PropTypes.func,
  updateRuleState: PropTypes.shape({
    loading: PropTypes.bool,
    success: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
      PropTypes.shape({
        message: PropTypes.string
      })
    ])
  })
}
